export default __webpack_public_path__ + "static/media/img4.aa9f9551.png";